import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetCatalogQuery, useMeQuery, useWorkspaceRecordsQuery } from '@platform/state/api';
import { useLabel } from '@platform/hooks/useLabel';
import { routes } from '@platform/core/lib/routes';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { mainRecordTypes } from '../shell/mainRecordTypes';
import { useRecentModules } from '../shell/navigator/recentModules';
import { pinnedKeys } from '../shell/pinnedKeys';
import { RecordsTable } from '../shell/RecordsTable';
import { recentlyUpdated } from '../shell/recordsTableItems';
import { useWorkspaceMeta } from '../shell/useWorkspaceMeta';
import '../shell/records.css';

const RECENT = 30;

/**
 * «Нещодавні» (прототип v4 G:L2633–2662, Головна › Моя робота): «30 нещодавно оновлених записів у просторі …», «Нещодавні модулі» —
 * чипи відкритих останніми модулів, що не закріплені (до 5), і таблиця записів головних таблиць, оновлених останніми.
 */
export function RecentPage() {
  const { t } = useTranslation();
  const label = useLabel();
  const { ws } = useWorkspaceParams();
  const { workspace } = useWorkspaceMeta(ws);
  const { data: me } = useMeQuery();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const { data } = useWorkspaceRecordsQuery({ ws, types: mainRecordTypes(catalog) }, { skip: !catalog });
  const items = data ? recentlyUpdated(data.items, ws, RECENT) : undefined;
  const pins = pinnedKeys(me, catalog, ws);
  const modules = useRecentModules(me?.id, ws).filter((k) => !pins.includes(k) && catalog?.modules.some((m) => m.key === k && m.installed)).slice(0, 5);
  return (
    <div className="rp-page">
      <div className="rp-head-block">
        <h1>{t('recordsPages.recentTitle')}</h1>
        <span className="muted">{t('recordsPages.recentSub', { count: items?.length ?? RECENT, ws: workspace?.name ?? '' })}</span>
      </div>
      {modules.length > 0 && (
        <div className="rp-chips">
          <span className="rp-chips__label">{t('recordsPages.recentModules')}</span>
          {modules.map((k) => <Link key={k} className="rp-chip" to={routes.module(k)}>{label(catalog?.modules.find((m) => m.key === k)?.name) || k}</Link>)}
        </div>
      )}
      <RecordsTable ws={ws} items={items} empty={t('recordsPages.empty')} />
    </div>
  );
}
